import { Screen } from '../interfaces';
export const preassessment: Screen = {
  component: 'assessment',
  key: 'pre'
};
